import React, { Component } from 'react';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Brush, ResponsiveContainer, ReferenceLine, Label
} from 'recharts';
import { useTranslation } from 'react-i18next';
import DateHelperInstance from '../../services/DateHelper';
import { format } from 'util';

class CustomizedLabel extends Component {
    render() {
        const { x, y, stroke, value } = this.props;
        return <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="middle">{DateHelperInstance.millisToMinutesSecondsAndMilliseconds(value)}</text>
    }
}

function ParticipantChart(props) {
    const { laps, bestLap, bestGroup, bestToday, bestCircuit, averageTime } = props;
    let bestLapId, bestLapTimeMs;
    if (bestLap) {
        bestLapId = bestLap.lapId;
        bestLapTimeMs = bestLap.timeMs;
    }
    const twiceBestTime = bestLapTimeMs * 2;
    // calculate the min and max values of the laps timeMS
    let min = 1000000000, max=0;
    laps.forEach(lap => {
        if (lap.timeMs < min) {
            min = lap.timeMs;
        }
        if (lap.timeMs > max && lap.timeMs < twiceBestTime) {
            max = lap.timeMs;
        }        
    });
    min = Math.min(min, bestCircuit > 0 ? bestCircuit : min, bestGroup, bestToday, bestLapTimeMs);
    max = Math.max(max, bestCircuit, bestGroup, bestToday, bestLapTimeMs);
    // set the domain of the Y axis to be between min and max
    let domain = [min - 10000, max + 10000];

    const { t } = useTranslation("common");
    return (
        <ResponsiveContainer>
            <LineChart
                // width={500}
                // height={200}
                data={laps}
                syncId="anyId"                
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="lapId" padding={{ left: 5, right: 5 }}>
                    <Label position="right">{t('rider.lap')}</Label>
                </XAxis>
                <YAxis domain = {domain} tickFormatter={t => DateHelperInstance.millisToMinutesAndSeconds(t)}>
                    <Label angle={270} position="left">{t('rider.chartTimeMs')}</Label>
                </YAxis>
                <Tooltip formatter={(value, name, props) => [props.payload.timeFormatted, format(t("rider.seenAt"), props.payload.readFormatted)]} />
                <Legend />
                <Brush dataKey="lapId" height={20} stroke="#446917" />
                <ReferenceLine x={bestLapId} stroke="red" label={t("rider.bestLapToday")} />
                <ReferenceLine y={bestLapTimeMs} label={t("rider.bestToday")} stroke="red" />
                <ReferenceLine y={bestGroup} label={t("rider.bestGroup")} stroke="pink" />
                <ReferenceLine y={bestToday} label={t("rider.bestEvent")} stroke="blue" />
                <ReferenceLine y={bestCircuit} label={t("rider.bestCircuit")} stroke="purple" />
                <ReferenceLine y={averageTime} label={t("rider.average")} stroke="brown" />
                <Line type="monotone" dataKey="timeMs" label={<CustomizedLabel />} stroke="#446917" fill="#8884d8" />
            </LineChart>

        </ResponsiveContainer >
    );
}

export default ParticipantChart;